import React, { useEffect, useState } from "react";
import { getDeletionAccess, getIsSuperAdmin } from "../../utils/api/deletion";

// Wraps a page the deletion feature keeps for Super Admins. Renders nothing while the role
// is being checked, so the page never flashes for someone who may not see it. The API
// enforces the same rule; this only keeps the screen itself from opening.
// [INC-2022] With `entity` the page opens for a Super Admin or a role holding that Deletion
// Management toggle; without it the page stays Super Admin only.
const SuperAdminOnly = ({ children, entity }) => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(null);

  useEffect(() => {
    (entity ? getDeletionAccess(entity) : getIsSuperAdmin())
      .then(setIsSuperAdmin)
      .catch(() => setIsSuperAdmin(false));
  }, [entity]);

  if (isSuperAdmin === null) return null;
  if (isSuperAdmin) return children;
  return (
    <div className="page-container eep">
      <p className="f-med f-14">
        {entity
          ? "You do not have permission to view this page."
          : "Only a Super Admin can view this page."}
      </p>
    </div>
  );
};

export default SuperAdminOnly;
